import React from 'react';
import useSessionContextContext from '../SessionContextContextProvider/useSessionContextContext';
import useSessionInfoContext from '../SessionInfoContextProvider/useSessionInfoContext';
import useDetectionNotifications from './Hooks/useDetectionNotifications';
import useDetectionNavigation from './Hooks/useSessionNavigation';
import { LatestDetection, SessionDetectionContext } from './useSessionDetectionContext';

export default function SessionDetectionContextProvider({ children }: { children: React.ReactNode }) {
  const [latestDetection, setLatestDetection] = React.useState<LatestDetection | null>(null);
  const { session } = useSessionInfoContext();
  const { setContext } = useSessionContextContext();

  React.useEffect(() => {
    if (latestDetection?.contextChange) {
      setContext(latestDetection.contextChange);
    }
  }, [latestDetection]);

  const value = React.useMemo(() => ({
    latestDetection,
    setLatestDetection,
  }), [latestDetection]);

  useDetectionNotifications(latestDetection);
  useDetectionNavigation(latestDetection, session);

  return (
    <SessionDetectionContext.Provider value={value}>
      {children}
    </SessionDetectionContext.Provider>
  );
}
